import { create } from 'zustand'
import { UserData } from '@/types/userTypes'

export interface UserState {
  User: UserData | null
  set: (user: UserData) => void
}

// The signed-in user is hydrated from the server session via /api/me (see the
// root route loader), not from a client-readable cookie.
export const useUserStore = create<UserState>((set) => ({
  User: null,
  set: (newUser) => set(() => ({ User: newUser })),
}))
